import {useEffect, useState} from "react";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";

const PrestationItem = ({sector, subCategories}) => {
  const [FilteredsubCategories, setFilteredsubCategories] = useState([]);

  useEffect(() => {
    if (!!subCategories?.length && !!sector.Categories?.length) {
      const categories = sector.Categories.map((category) => {
        return category.id;
      });
      let filteredSubCategories = subCategories.filter((ele) => {
        return categories.includes(ele.fatherId);
      });
      setFilteredsubCategories(filteredSubCategories);
    }
  }, [subCategories, sector]);

  return (
    <div className="flex flex-col gap-3 justify-start items-start w-full">
      <div className="flex gap-2 items-center">
        <div className=" aspect-square rounded-full flex justify-center items-center ">
          <img src={buildImageUrl(sector.imagePath)} alt="" className="w-6" />
        </div>
        <div className="font-bold text-base   text-[#19295C]">
          {sector.title}
        </div>
      </div>
      <div className="flex justify-start items-center flex-wrap gap-2">
        {!!FilteredsubCategories?.length &&
          FilteredsubCategories.map((ele) => (
            <div
              key={ele?.id}
              className=" bg-gradient-to-r from-[#0022AA1A] to-[#1A64B91A] gap-2  font-medium text-xs  rounded-3xl px-4 py-2 flex justify-center items-center text-[#1A64B9] "
            >
              {ele.title}{" "}
            </div>
          ))}
      </div>
    </div>
  );
};
export default PrestationItem;
